import React from 'react';
import { FaRegCalendarPlus } from 'react-icons/fa';

const ShoppingListEmptyState: React.FC = () => (
  <div className="fixed inset-0 flex items-center justify-center bg-white px-4">
    <div className="w-full max-w-md text-center">
      <p className="text-sm text-gray-500 mb-2">
        You have not planned meals in the selected period
      </p>
      <p className="text-lg text-gray-700 font-medium">
        Start by adding recipes
        {/* <span className="inline-flex items-center justify-center w-6 h-6 bg-black text-white rounded-full mx-1"> */}
        <span className="inline-flex items-center justify-center w-6 h-6 bg-white text-black mx-1">
          <FaRegCalendarPlus className="w-5 h-5" />
        </span>
        to your meal plan
      </p>
    </div>
  </div>
);

export default ShoppingListEmptyState;
